export default {
  'menu.attraction.setting': '招商设置',
  'menu.attraction.claimConversion': '领取与转化规则',
  'menu.navigation.contractSettings': '合同设置',
  'menu.contractTypes': '合同类型',
  'menu.navigation.contractHandling': '合同办理',
  'menu.navigation.contractAll': '全部合同',
  'menu.navigation.contractMine': '我的合同',
  'menu.navigation.contractTodo': '待办合同',
  'menu.contractTemplates': '合同模板库',
  'menu.contractBillingRules': '计费规则',
  'menu.newContract': '拟定合同',
  'menu.editContract': '编辑合同',
  'menu.contractDetail': '合同详情',
  'menu.attraction.investmentOrders': '订单',
  'menu.attraction.opportunityDetail': '商机详情',
  'menu.attraction.newInvestmentOrder': '新建订单',
  'menu.attraction.editInvestmentOrder': '编辑订单',
  'menu.attraction.investmentOrderDetail': '订单详情',
  'menu.navigation.module.home': '首页',
  'menu.navigation.module.assets': '房源',
  'menu.navigation.module.asset': '资产',
  'menu.navigation.module.attraction': '招商',
  'menu.navigation.module.enterprises': '企业',
  'menu.navigation.module.reports': '报表',
  'menu.navigation.module.contracts': '合同',
  'menu.navigation.module.property': '物业',
  'menu.navigation.module.innovation': '企服',
  'menu.navigation.module.operations': '运营',
  'menu.navigation.module.hr': '人事',
  'menu.navigation.module.finance': '财务',
  'menu.navigation.module.evaluation': '评价',
  'menu.navigation.module.settings': '设置',
  'menu.attraction.leads': '线索',
  'menu.attraction.customers': '客户',
  'menu.leadAll': '全部',
  'menu.leadMine': '我的线索',
  'menu.leadPool': '待领线索',
  'menu.customerAll': '全部',
  'menu.customerMine': '我的客户',
  'menu.customerPool': '待领客户',
  'menu.attraction.leadAll': '全部线索',
  'menu.attraction.leadMine': '我的线索',
  'menu.attraction.leadPool': '待领线索',
  'menu.attraction.customerAll': '全部客户',
  'menu.attraction.customerMine': '我的客户',
  'menu.attraction.customerPool': '待领客户',
  'menu.attraction.contacts': '联系人',
  'menu.attraction.opportunities': '商机',
  'menu.workbench': '工作台',
  'menu.home': '首页',
  'menu.assets': '资产房源',
  'menu.business': '业务管理',
  'menu.contracts': '合同台账',
  'menu.innovation': '科创服务',
  'menu.hr': '人事管理',
  'menu.finance': '财务管理',
  'menu.finance.overview': '财务总览',
  'menu.finance.receivables': '应收管理',
  'menu.finance.receipts': '收款管理',
  'menu.finance.collectionLedger': '催缴台账',
  'menu.finance.expenses': '费用申请',
  'menu.finance.invoices': '发票管理',
  'menu.reports': '数据报表',
  'menu.reports.overview': '报表总览',
  'menu.reports.investment': '招商报表',
  'menu.reports.finance': '财务收费报表',
  'menu.reports.property': '物业运维报表',
  'menu.reports.settings': '报表设置',
  'menu.login': '登录',
  'menu.settings': '系统设置',
  'menu.settings.permissions': '权限管理',
  'menu.settings.spaceConfig': '房源配置',
  'menu.settings.approvalConfig': '审批配置',
  'menu.settings.dictionaries': '基础字典',
  'menu.settings.numberingRules': '编号规则',
  'menu.settings.auditLogs': '操作日志',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.overview': '概览',
  'menu.todos.group': '待办中心',
  'menu.todos.todoApproval': '待我审批',
  'menu.todos.todoBusiness': '业务待办',
  'menu.todos': '待办中心',
  'menu.parkSetup': '园区初始化',
  'menu.parkCreate': '创建园区',
  'menu.parkSelect': '选择园区',
  'menu.parkBootstrapError': '园区加载失败',
  'menu.park': '园区',
  'menu.park.profile': '园区信息',
  'menu.park.spaceManagement': '房源管理',
  'menu.park.spaceManagement.spacesOverview': '房源总览',
  'menu.park.spaceManagement.spaces': '房源档案',
  'menu.park.spaceManagement.otherAssets': '其他资产',
  'menu.asset': '资产',
  'menu.asset.detail': '资产详情',
  'menu.asset.ledger': '资产台账',
  'menu.asset.suppliers': '供应商库',
  'menu.asset.reminders': '到期提醒',
  'menu.park.spaceManagement.spaceIncubation': '孵化档案',
  'menu.park.spaceManagement.spaceDetail': '房源详情',
  'menu.park.spaceManagement.spaceUsage': '房源使用',
  'menu.park.leases': '租赁管理',
  'menu.park.leases.leasePlans': '租赁方案',
  'menu.park.leases.leaseLedger': '租赁台账',
  'menu.park.leases.leaseRenewals': '续租申请',
  'menu.park.leases.leaseTerminations': '退租申请',
  'menu.park.property': '物业管理',
  'menu.park.property.workOrders': '物业工单',
  'menu.park.property.accessControl': '门禁管理',
  'menu.park.property.parking': '停车管理',
  'menu.park.property.energy': '能耗管理',
  'menu.park.property.iotDevices': 'IoT 设备',
  'menu.property': '物业管理',
  'menu.property.propertyDashboard': '物业工作台',
  'menu.property.workOrders': '物业工单',
  'menu.property.propertySlaRules': '工单配置',
  'menu.property.accessControl': '门禁管理',
  'menu.property.parking': '停车管理',
  'menu.property.meetingRoom': '会议室管理',
  'menu.property.energyMeters': '表计档案',
  'menu.property.energy': '能耗管理',
  'menu.property.energySpaces': '房源台账',
  'menu.property.energyLedger': '抄表台账',
  'menu.property.energyAccounts': '企业账户',
  'menu.property.energyRates': '计费规则',
  'menu.property.iotDevices': '物联设备',
  'menu.enterprises': '企业',
  'menu.attraction': '招商管理',
  'menu.attraction.investmentProjects': '招商项目',
  'menu.attraction.admissionApplications': '入驻申请',
  'menu.attraction.list': '企业库',
  'menu.enterprises.attraction': '招商入驻',
  'menu.enterprises.attraction.investmentProjects': '招商项目',
  'menu.enterprises.attraction.admissionApplications': '入驻申请',
  'menu.enterprises.attraction.list': '企业库',
  'menu.enterprises.entries': '入驻管理',
  'menu.enterprises.exits': '迁出管理',
  'menu.enterprises.visits': '企业走访',
  'menu.enterprises.requests': '企业诉求',
  'menu.enterprises.incubation': '孵化辅导',
  'menu.enterprises.incubation.incubationPlans': '孵化计划',
  'menu.enterprises.incubation.mentors': '创业导师',
  'menu.enterprises.archives': '企业档案',
  'menu.enterprises.archives.qualifications': '企业资质',
  'menu.enterprises.archives.intellectualProperties': '知识产权',
  'menu.enterprises.archives.annualData': '年度数据',
  'menu.growth': '企业成长',
  'menu.growth.models': '成长模型',
  'menu.growth.archives': '成长档案',
  'menu.growth.evaluations': '阶段评估',
  'menu.growth.recommendationRules': '推荐规则',
  'menu.services': '服务',
  'menu.services.handling': '事项办理',
  'menu.services.handling.matters': '服务事项',
  'menu.services.handling.applications': '服务申请',
  'menu.services.marketplace': '服务市场',
  'menu.services.marketplace.demands': '服务需求',
  'menu.services.marketplace.catalog': '服务目录',
  'menu.services.marketplace.providers': '服务商管理',
  'menu.services.marketplace.orders': '服务订单',
  'menu.services.marketplace.fulfillments': '服务履约',
  'menu.services.marketplace.reviews': '服务评价',
  'menu.resources': '资源中心',
  'menu.resources.investment': '投融资资源',
  'menu.resources.technology': '科技资源',
  'menu.resources.technology.technologyResults': '科技成果',
  'menu.resources.technology.researchInstitutions': '高校院所',
  'menu.resources.technology.experts': '专家人才',
  'menu.resources.technology.technologyManagers': '技术经理人',
  'menu.resources.ecosystem': '生态资源',
  'menu.operations.partyBuilding': '党建',
  'menu.operations': '运营管理',
  'menu.operations.activities': '园区活动',
  'menu.operations.activityOps': '活动运营',
  'menu.operations.policies': '政策管理',
  'menu.operations.announcements': '通知公告',
  'menu.operations.content': '内容运营',
  'menu.evaluation': '评价',
  'menu.evaluation.overview': '概览',
  'menu.evaluation.indicatorSystems': '指标体系',
  'menu.evaluation.dataCollections': '数据采集',
  'menu.evaluation.evidence': '佐证材料',
  'menu.evaluation.tasks': '评价任务',
  'menu.evaluation.reports': '评价报告',
  'menu.portal': '门户管理',
  'menu.portal.overview': '门户概览',
  'menu.portal.site': '门户内容',
  'menu.portal.site.pages': '页面管理',
  'menu.portal.site.columns': '栏目管理',
  'menu.portal.site.contents': '内容管理',
  'menu.portal.site.banners': '横幅管理',
  'menu.portal.publish': '发布设置',
  'menu.portal.publish.releases': '发布管理',
  'menu.portal.publish.settings': '门户设置',
  'menu.navigation.admission': '入驻与迁出',
  'menu.navigation.incubationGrowth': '孵化成长',
  'menu.navigation.resourceMatching': '资源对接',
  'menu.navigation.detail': '详情',
  'menu.navigation.create': '新建',
  'menu.navigation.edit': '编辑',
  'menu.navigation.claimReview': '认领审核',
  'menu.navigation.reads': '阅读记录',
};
